import React, { useState, useEffect } from "react";
import axios from "axios";
import InputOption from "../../component/InputOption/InputOption";

const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}`;
};

const budgetActive = () => localStorage.getItem('budgetActive');

const ReportProfitLossBudget = () => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_BUDGET = "api/erpppsu/budget";
    const PATH_REPORT = "api/erpppsu/report/AnggaranLabarugi";

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [optionBudget, setOptionBudget] = useState([]);
    const [budgetSelected, setBudgetSelected] = useState(budgetActive());    
    const [filterInterval, setFilterInterval] = useState("weekly");
    const [filterTotalInterval, setFilterTotalInterval] = useState(1);
    const [filterLastDate, setFilterLastDate] = useState(getTodayDate());

    // Fetch data from the API
    const fetchData = async (URL, config) => {
        setLoading(true);
        try {
            const response = await axios.get(URL, config);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    // Fetch data on component mount
    useEffect(() => {
        if (budgetSelected && filterInterval && filterTotalInterval && filterLastDate) {
            fetchData(`${BASE_URL}${PATH_REPORT}?budget=${budgetSelected}&interval=${filterInterval}&total_interval=${filterTotalInterval}&last_date=${filterLastDate}`).then((data) => {
                setData(data || []); // Ensure `data` is an array
            });
        }

        fetchData(`${BASE_URL}${PATH_BUDGET}/option`).then((data) => {
            setOptionBudget(data);
        });
    }, []);

    const handleFilter = () => {
        if (budgetSelected && filterInterval && filterTotalInterval && filterLastDate) {
            fetchData(`${BASE_URL}${PATH_REPORT}?budget=${budgetSelected}&interval=${filterInterval}&total_interval=${(filterTotalInterval)}&last_date=${filterLastDate}`).then((data) => {
                setData(data || []); // Ensure `data` is an array
            });
        }
    }

    if (error) return <div className="text-red-500">{error}</div>;

    return (
        <div className="p-4">
            <h1 className="text-lg font-bold mb-4">Anggaran Laba Rugi</h1>

            <div className="container m-auto grid grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-5 my-3 gap-4">
                <div className="">
                    <InputOption
                        label="Pilih Anggaran"
                        data={optionBudget}
                        placeholder="Ketik disini"
                        defaultValue={budgetSelected}
                        onChange={(value) => {
                            localStorage.setItem('budgetActive', value);
                            setBudgetSelected(value);
                        }} />
                </div>
            </div>

            <div className="container m-auto grid grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-5 my-3 gap-4">
                {/* Last Date Input */}
                <div className="mx-1">
                    <label htmlFor="last_date" className="block mb-1 text-sm font-semibold">
                        Tanggal Akhir
                    </label>
                    <input
                        id="last_date"
                        name="last_date"
                        type="month"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        defaultValue={filterLastDate}
                        onChange={(e) => setFilterLastDate(e.target.value)}
                    />
                </div>

                {/* Interval Dropdown */}
                <div className="mx-1">
                    <label htmlFor="interval" className="block mb-1 text-sm font-semibold">
                        Interval
                    </label>
                    <select
                        id="interval"
                        name="interval"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        onChange={(e) => setFilterInterval(e.target.value)}
                    >
                        {/* <option  value="weekly">Minggu</option> */}
                        <option selected value="monthly">Bulan</option>
                    </select>
                </div>

                {/* Total Interval Dropdown */}
                <div className="mx-1">
                    <label htmlFor="total_interval" className="block mb-1 text-sm font-semibold">
                        Jumlah Interval Ditampilkan
                    </label>
                    <select
                        id="total_interval"
                        name="total_interval"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        onChange={(e) => setFilterTotalInterval(e.target.value)}
                    >
                        {Array.from({ length: 12 }).map((_, index) => (
                            <option key={index} value={index + 1}>
                                {index + 1}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Filter Button */}
                <div className="p-3 flex items-end">
                    <button
                        onClick={handleFilter}
                        type="button"
                        className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200"
                    >
                        Filter
                    </button>
                </div>
            </div>

            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (data.map((section, index) => {
                // Extract periods and totals from the section
                const periods = section.account[0]?.report.map((report) => report.period) || [];
                const totals = section.total;
                const totals_budget = section.total_budget;

                return (
                    <div key={index} className="mb-6">
                        <h2 className="text-md font-semibold mb-2">Section {index + 1}</h2>

                        {/* Table */}
                        <table className="min-w-full border-collapse border border-gray-300">
                            <thead>
                                <tr>
                                    <th className="border border-gray-300 px-4 py-2" rowSpan={2}>ID</th>
                                    <th className="border border-gray-300 px-4 py-2" rowSpan={2}>Account Name</th>
                                    {periods.map((period, periodIndex) => (
                                        <th
                                            key={periodIndex}
                                            className="border border-gray-300 px-4 py-2"
                                            colSpan={5}
                                        >
                                            {period}
                                        </th>
                                    ))}
                                </tr>
                                <tr>
                                    {periods.map((period, periodIndex) => (
                                        <>
                                            <th
                                                key={periodIndex}
                                                className="border border-gray-300 px-4 py-2"
                                            >
                                                Aktual
                                            </th>
                                            <th
                                                key={periodIndex}
                                                className="border border-gray-300 px-4 py-2"
                                            >
                                                Anggaran
                                            </th>
                                            <th
                                                key={periodIndex}
                                                className="border border-gray-300 px-4 py-2"
                                            >
                                                Aktual Tahun Lalu
                                            </th>
                                            <th
                                                key={periodIndex}
                                                className="border border-gray-300 px-4 py-2"
                                            >
                                                Aktual vs <br></br>Aktual Tahun Lalu
                                            </th>
                                            <th
                                                key={periodIndex}
                                                className="border border-gray-300 px-4 py-2"
                                            >
                                                Aktual vs <br></br>Anggaran
                                            </th>
                                        </>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {section.account.map((account) => (
                                    <tr key={account.id}>
                                        <td className="border border-gray-300 px-4 py-2">{account.id}</td>
                                        <td className="border border-gray-300 px-4 py-2">{account.name}</td>
                                        {account.report.map((report, reportIndex) => (
                                            <>
                                                <td
                                                    key={reportIndex}
                                                    className="border border-gray-300 px-4 py-2 text-end"
                                                >
                                                    {report.actual.toLocaleString("id-ID", { minimumFractionDigits: 0 })}
                                                </td>
                                                <td
                                                    key={reportIndex}
                                                    className="border border-gray-300 px-4 py-2 text-end"
                                                >
                                                    {report.budget.toLocaleString("id-ID", { minimumFractionDigits: 0 })}
                                                </td>
                                                <td
                                                    key={reportIndex}
                                                    className="border border-gray-300 px-4 py-2 text-end"
                                                >
                                                    {report.actual_prev.toLocaleString("id-ID", { minimumFractionDigits: 0 })}
                                                </td>
                                                <td
                                                    key={reportIndex}
                                                    className="border border-gray-300 px-4 py-2 text-end"
                                                >
                                                    {report.actual_vs_actual_prev.toLocaleString("id-ID", { minimumFractionDigits: 0 })}
                                                </td>
                                                <td
                                                    key={reportIndex}
                                                    className="border border-gray-300 px-4 py-2 text-end"
                                                >
                                                    {report.actual_vs_budget.toLocaleString("id-ID", { minimumFractionDigits: 0 })}
                                                </td>
                                            </>
                                        ))}
                                    </tr>
                                ))}
                                {/* Totals Row */}
                                <tr>
                                    <td
                                        className="border border-gray-300 px-4 py-2 font-bold"
                                        colSpan={2}
                                    >
                                        Total
                                    </td>
                                    {periods.map((period, periodIndex) => (
                                        <>
                                            <td
                                                key={periodIndex}
                                                className="border border-gray-300 px-4 py-2 font-bold text-end"
                                            >
                                                {totals[period].toLocaleString("id-ID", { minimumFractionDigits: 0 })}
                                            </td>
                                            <td
                                                key={periodIndex}
                                                className="border border-gray-300 px-4 py-2 font-bold text-end"
                                            >
                                                {totals_budget[period].toLocaleString("id-ID", { minimumFractionDigits: 0 })}
                                            </td>
                                        </>
                                    ))}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            }))}
        </div>
    );
};

export default ReportProfitLossBudget;
